export default __webpack_public_path__ + "static/brand-introduction-2c905e95dcb43ee8227f3e633c995aa7.png";